<template>
  <router-link
    :to="{
      name: 'lister-project-details',
      params: { id: project._id },
    }"
  >
    <v-card class="mx-auto">
      <div class="detail-overlay">
        <p>{{ project.description.substring(0, 100) }}...</p>
        <button>Read more</button>
      </div>
      <v-img
        class="white--text align-end my-image"
        height="200px"
        :src="project.file.split(',')[0]"
        lazy-src="https://picsum.photos/id/11/100/60"
      >
        <v-card-title class="tw-bg-black tw-opacity-50">{{
          project.name
        }}</v-card-title>
      </v-img>
      <v-card-text class="">
        <section>
          <!-- <strong>Description:</strong> {{ project.description }} -->
        </section>
        <!-- <section><strong>Tonnage/month:</strong> {{ project.tonnage }}</section> -->
      </v-card-text>
    </v-card>
  </router-link>
</template>

<script>
export default {
  props: ["project"],
};
</script>

<style lang="css" scoped>
.my-image {
  background: rgba(1, 6, 12, 0.82);
  overflow: hidden;
  height: 100%;
  z-index: 2;
}

.detail-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  text-align: center;
  z-index: 100;
  background-color: #000;
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  transition: opacity 0.25s ease-in;
}

.detail-overlay:hover {
  opacity: 0.6;
}

.detail-overlay p {
  color: #fff;
}

.detail-overlay button {
  color: #fff;
  border: 1px solid #fff;
  padding: 5px;
  text-align: center;
  width: fit-content;
}
</style>
